import { type ActivityTypesEnum, type FetchSocialFeedMeByFeedSlugParams, useLocale } from '@capsicum/common';
import { mySociosFeedKeys } from '@capsicum/socios-core';
import { useAtomValue } from 'jotai';

import { followedTeamsFeedFiltersAtom, useSocialFeedMeQuery } from '../data-access';
import { type FeedFiltersMapType } from '../models';
import { clearFeedPages, prepareFeedData } from '../util';

/**
 * @warning DON'T USE this hook directly! use the one implemented on useFollowedTeamsFeedWEB or useFollowedTeamsFeedMOB files instead.
 */
export const useFollowedTeamsFeed = (filtersMap: FeedFiltersMapType) => {
	const { locale } = useLocale();
	const { partners = [], selectedFilters } = useAtomValue(followedTeamsFeedFiltersAtom);
	const key = [...mySociosFeedKeys.followedTeams, selectedFilters, ...partners];
	const activityTypes = selectedFilters
		.map((x: any) => filtersMap.get(x) || [])
		.flat() as unknown as Array<ActivityTypesEnum>;

	const params: FetchSocialFeedMeByFeedSlugParams = {
		'activityTypes[]': activityTypes,
		feedSlug: 'todo_followed',
		limit: 10,
		locale: locale,
		'partnerIds[]': partners
	};

	const {
		data,
		error,
		fetchNextPage,
		hasNextPage,
		isFetching,
		isLoading,
		refetch: refetchQuery
	} = useSocialFeedMeQuery(key, params);

	const { feedData, metadata } = prepareFeedData(data);

	const refetch = async () => {
		clearFeedPages(key);
		await refetchQuery();
	};

	return {
		data: feedData,
		error,
		fetchNextPage,
		hasNextPage,
		isFetching,
		isLoading,
		metadata,
		refetch
	};
};
